var _defs, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQsRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#e81da4;}.cls-1{opacity:0.1;}.cls-2{fill-rule:evenodd;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 21,
    cy: 21,
    r: 21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.21,12.71a1,1,0,0,0-1.42-1.42l-3.5,3.5a1,1,0,0,0,0,1.42l3.5,3.5a1,1,0,0,0,1.42-1.42l-1.8-1.79H25a3,3,0,0,1,3,3,1,1,0,0,0,2,0,5,5,0,0,0-5-5H14.41Zm9.58,16.58a1,1,0,0,0,1.42,1.42l3.5-3.5a1,1,0,0,0,0-1.42l-3.5-3.5a1,1,0,0,0-1.42,1.42l1.8,1.79H17a3,3,0,0,1-3-3,1,1,0,0,0-2,0,5,5,0,0,0,5,5H27.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQsRefresh);
export default __webpack_public_path__ + "static/media/qs-refresh.0a8b909d713ee0ad264baa8c29379546.svg";
export { ForwardRef as ReactComponent };